import { useEffect, useState } from "react";
import axios from "axios";

export default function User() {
  const [websites, setWebsites] = useState([]);

  useEffect(() => {
    const token = localStorage.getItem("token");

    axios.get(
      `/api/user/websites`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    )
    .then(res => setWebsites(res.data))
    .catch(err => console.error(err));

  }, []);

  if (!websites.length) {
    return <p className="text-white">Nema registrovanih sajtova.</p>;
  }

    return (
    <div className="container mt-5">

      {/* Glass Card */}
      <div
        className="p-5 rounded-4"
        style={{
          background: "rgba(255,255,255,0.03)",
          backdropFilter: "blur(20px)",
          border: "1px solid rgba(255,255,255,0.08)",
          color: "#fff"
        }}
      >

        {/* Header */}
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h2 className="fw-semibold mb-0">Moji sajtovi</h2>

          <span
            className="px-3 py-1 rounded-pill"
            style={{
              background: "linear-gradient(135deg,#4f46e5,#9333ea)",
              fontSize: "13px",
              fontWeight: "500"
            }}
          >
            {websites.length} ukupno
          </span>
        </div>

        {/* Custom Table */}
        <div className="table-responsive">
          <table
            className="w-100"
            style={{
              borderCollapse: "separate",
              borderSpacing: "0 12px"
            }}
          >
            <thead>
              <tr style={{ color: "rgba(255,255,255,0.6)", fontSize: "14px" }}>
                <th>ID</th>
                <th>REF BROJ</th>
                <th>Naziv</th>
                <th>HTTP</th>
                <th>Domen expire</th>
                <th>Hosting expire</th>
                <th>Održavanje</th>
              </tr>
            </thead>

            <tbody>
              {websites.map(w => (
                <tr
                  key={w.sajtID}
                  style={{
                    background: "rgba(255,255,255,0.04)",
                    transition: "all 0.3s ease",
                    borderRadius: "12px"
                  }}
                  onMouseEnter={e => {
                    e.currentTarget.style.background = "rgba(255,255,255,0.07)";
                    e.currentTarget.style.transform = "scale(1.01)";
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.background = "rgba(255,255,255,0.04)";
                    e.currentTarget.style.transform = "scale(1)";
                  }}
                >
                  <td className="p-3 fw-light">{w.sajtID}</td>
                  <td className="p-3 fw-light">{w.ref_num}</td>
                  <td className="p-3 fw-medium">{w.naziv}</td>

                  <td className="p-3">
                    <a
                      href={w.httpadresa}
                      target="_blank"
                      rel="noreferrer"
                      style={{
                        color: "#60a5fa",
                        textDecoration: "none"
                      }}
                    >
                      {w.httpadresa}
                    </a>
                  </td>

                  <td className="p-3">{w.domen_expire}</td>

                  <td className="p-3">{w.hosting_expire}</td>

                  <td className="p-3">
                    <span
                      className="px-3 py-1 rounded-pill"
                      style={{
                        fontSize: "12px",
                        fontWeight: "500",
                        background:
                          w.odrzavanje === "Aktivno"
                            ? "linear-gradient(135deg,#22c55e,#15803d)"
                            : "linear-gradient(135deg,#ef4444,#b91c1c)"
                      }}
                    >
                      {w.odrzavanje}
                    </span>
                  </td>

                </tr>
              ))}
            </tbody>
          </table>
        </div>

      </div>
    </div>
  );
}